import { Component, OnInit } from '@angular/core';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { Router, NavigationStart } from '@angular/router';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.css'],
  providers: [Modal]
})
export class AlertPopupComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }

  ngOnInit() {
    this.modalData = this.dialog.context.modalData;
    this.modalData.Action = this.modalData.Action == undefined ? 'Continue' : this.modalData.Action;
  }
  continueClick() {
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }
  closeClick() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/alert-popup/alert-popup.component.ts